import React from "react";
import { NavLink } from "react-router-dom";
import { Home, Compass, BookOpen, BarChart3, Settings } from "lucide-react";

const items = [
  { to: "/home", label: "Home", icon: Home, testid: "nav-home" },
  { to: "/journey", label: "Journey", icon: Compass, testid: "nav-journey" },
  { to: "/journal-history", label: "Journal", icon: BookOpen, testid: "nav-journal" },
  { to: "/progress", label: "Progress", icon: BarChart3, testid: "nav-progress" },
  { to: "/settings", label: "Settings", icon: Settings, testid: "nav-settings" },
];

export default function BottomNav() {
  return (
    <nav
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md h-20 z-50"
      data-testid="bottom-nav"
    >
      <div className="mx-3 mb-3 rounded-3xl bps-glass flex justify-around items-center h-16 px-2">
        {items.map(({ to, label, icon: Icon, testid }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={testid}
            className={({ isActive }) =>
              `flex flex-col items-center gap-0.5 px-3 py-1 rounded-2xl transition-all duration-300 ${
                isActive ? "text-[#22D3EE]" : "text-[#7C8FA8] hover:text-white"
              }`
            }
          >
            <Icon size={20} strokeWidth={1.6} />
            <span className="text-[10px] font-medium tracking-wide">{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
